import {
    area as d3Area,
    CurveFactory,
    curveLinear,
    curveNatural,
    curveStepAfter,
    line as d3Line,
} from 'd3';
import {
    LinePlotCurveStyle,
    Point,
    ShadedPlotShadeDirection,
} from 'shared/chart/core/types';

export const ShadedPlotOpacity = 0.5;

export const D3Curves: Readonly<Record<LinePlotCurveStyle, CurveFactory>> = {
    linear: curveLinear,
    // monotoneX: curveMonotoneX, // this should arguably be used in place of `natural` in some places
    // monotoneY: curveMonotoneY,
    natural: curveNatural,
    stepAfter: curveStepAfter,
};

export type GetLinePathOptions = Readonly<{
    dataPoints: Point[];
    curveStyle: LinePlotCurveStyle;
}>;

export const getLinePath = ({ dataPoints, curveStyle }: GetLinePathOptions) =>
    dataPoints.length > 1
        ? d3Line<Point>()
              .x(({ x }) => x)
              .y(({ y }) => y)
              .curve(D3Curves[curveStyle])(dataPoints) ?? undefined
        : undefined;

export type GetShadedPathOptions = GetLinePathOptions &
    Readonly<{
        direction: ShadedPlotShadeDirection;
        width: number;
        height: number;
    }>;

export const getShadedPath = ({
    dataPoints,
    curveStyle,
    direction,
    width,
    height,
}: GetShadedPathOptions) => {
    if (dataPoints.length < 2) {
        return undefined;
    }
    switch (direction) {
        case 'up':
        case 'down':
            return d3Area<Point>()
                .x(({ x }) => x)
                .y0(direction === 'up' ? -height : height * 2)
                .y1(({ y }) => y)
                .curve(D3Curves[curveStyle])(dataPoints);
        case 'left':
        case 'right':
            return d3Area<Point>()
                .x0(direction === 'left' ? -width : width * 2)
                .x1(({ x }) => x)
                .y(({ y }) => y)
                .curve(D3Curves[curveStyle])(dataPoints);
        default:
            throw new Error('Invalid shade direction');
    }
};
